'use strict';

var VisualElement = require('../VisualElement.cjs');
var DOMKeyframesResolver = require('../../../../../../../motion-dom/dist/es/animation/keyframes/DOMKeyframesResolver.cjs');
var isMotionValue = require('../../../../../../../motion-dom/dist/es/value/utils/is-motion-value.cjs');

class DOMVisualElement extends VisualElement.VisualElement {
    constructor() {
        super(...arguments);
        this.KeyframeResolver = DOMKeyframesResolver.DOMKeyframesResolver;
    }
    sortInstanceNodePosition(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */
        return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    }
    getBaseTargetFromProps(props, key) {
        return props.style
            ? props.style[key]
            : undefined;
    }
    removeValueFromRenderState(key, { vars, style }) {
        delete vars[key];
        delete style[key];
    }
    handleChildMotionValue() {
        if (this.childSubscription) {
            this.childSubscription();
            delete this.childSubscription;
        }
        const { children } = this.props;
        if (isMotionValue.isMotionValue(children)) {
            this.childSubscription = children.on("change", (latest) => {
                if (this.current) {
                    this.current.textContent = `${latest}`;
                }
            });
        }
    }
}

exports.DOMVisualElement = DOMVisualElement;
//# sourceMappingURL=DOMVisualElement.cjs.map
